import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react'

const footerLinks = [
  { href: '#sobre', label: 'Sobre o Projeto' },
  { href: '#documentos', label: 'Documentos e Anexos' },
  { href: '#faq', label: 'Perguntas Frequentes' },
  { href: '#galeria', label: 'Galeria' },
]

export function Footer() {
  return (
    <footer className="bg-[#111827] text-gray-300" role="contentinfo">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#51A64D] rounded-lg flex items-center justify-center text-white font-bold text-xs font-serif">
                CP
              </div>
              <div>
                <div className="font-serif font-bold text-white text-sm">CGPPP Porto Velho</div>
                <div className="text-[10px] text-gray-400">Concessão de Parques Urbanos</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-gray-400">
              Portal institucional do Conselho Gestor de Parcerias Público-Privadas para divulgação dos estudos e procedimentos referentes à concessão dos parques urbanos de Porto Velho/RO.
            </p>
          </div>

          <div>
            <h3 className="font-serif font-bold text-white text-sm mb-4">Links Rápidos</h3>
            <ul className="space-y-2 text-sm">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://portovelho.ro.gov.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors inline-flex items-center gap-1"
                >
                  Portal da Prefeitura <ExternalLink size={12} />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif font-bold text-white text-sm mb-4">Contato Institucional</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail size={14} className="mt-0.5 shrink-0 text-[#51A64D]" />
                <span>cgp.pvh@portovelho.ro.gov.br</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={14} className="mt-0.5 shrink-0 text-[#51A64D]" />
                <span>(69) 99204-0403</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-0.5 shrink-0 text-[#51A64D]" />
                <span>
                  Prefeitura Municipal de Porto Velho
                  <br />
                  Porto Velho – RO
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Prefeitura Municipal de Porto Velho – CGPPP/PVH. Todos os direitos reservados.</p>
          <div className="flex items-center gap-4">
            <a href="#contato" className="hover:text-gray-300 transition-colors">
              Ouvidoria
            </a>
            <a href="#contato" className="hover:text-gray-300 transition-colors">
              Acesso à Informação (LAI)
            </a>
            <a href="#" className="hover:text-gray-300 transition-colors">
              Política de Privacidade
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}